import { RadioControl } from '@myhrbox/myhrbox-frontend-core';
import { QuestionFull } from 'store/assessment/types';

interface SingleChoiceAnswerProps {
  currentQuestion: QuestionFull;
}

const SingleChoiceAnswer = ({ currentQuestion }: SingleChoiceAnswerProps) => {
  return (
    <RadioControl
      name='partId'
      items={currentQuestion?.parts?.map((part) => ({
        id: part.id,
        value: part.id,
        label: part.content,
      }))}
    />
  );
};

export default SingleChoiceAnswer;
